"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getAttr_1 = require("./getAttr");
exports.getAttrOrDefault = (el, attr, defaultValue) => {
    const val = getAttr_1.getAttr(el, attr);
    if (val === null) {
        return defaultValue;
    }
    return val;
};
//# sourceMappingURL=getAttrOrDefault.js.map